import {Color} from "three";
import * as THREE from "three";

export const MATERIAL_PROPS_DB = [



    {
        materialName:"FloorMat",

        roughness:0.40,
        // toneMapped:true,
    },

    {
        materialName:"GlassMat",
        glass:true,
        glassMatFunc: (envMap)=> {
            return new THREE.MeshPhysicalMaterial( {
                name: `GlassMat-MPM`,
                color: new THREE.Color(255,255,255),
                metalness: 0,
                roughness: 0,
                // alphaMap: texture,
                alphaTest: 0.5,
                envMap:  envMap, //this.backgroundMap,
                envMapIntensity: .2,
                depthWrite: false,
                transmission: .7, // use material.transmission for glass materials
                opacity: 1, // set material.opacity to 1 when material.transmission is non-zero
                transparent: true
            } );
        },
    },


    {
        materialName: "ReceptionCylinderMat",

        envMapIntensity: 3.9413043478260867,

    },


    {
        materialName: "CeilingMat",

        envMapIntensity: 2.741579990660218,

    },


    {
        materialName: "Walls_16_17_18_mat",
        aOIntensity: 0.8539356077552847,

    },


    {
        materialName: "BirdMat2",

        envMapIntensity: 2.7426421404682273,

        toneMapped: 'N',
    },


    {
        materialName: "WallsWhiteMat",
        aOIntensity: .6,

        envMapIntensity: 2.5,

    },

    {
        materialName:"Walls_yellow_mat",
        aOIntensity:0.8218328832168038,
        envMapIntensity: 4.1,

    },

    {
        materialName:"PricePlenthMat",
        aOIntensity:0.6613192605243994,

    },









]



